<script setup name="Template4">
import { ref, onMounted, onUnmounted, inject } from "vue";
import ContainerCom from "./ContainerCom.vue";
import TextCom from "./TextCom.vue";
import { ElMessageBox } from "element-plus";

// 为模板组件定义属性
const props = defineProps({
  templateId: {
    type: String,
    default: "",
  },
});
// 处理删除事件
const handleDelete = (contentId) => {
  // emit删除事件
  emit("handleDelete", props.templateId);
};
// 定义emits
const emit = defineEmits(["edit", "handleDelete"]);
const isLoggedIn = inject("isLoggedIn");
// 淡入动画相关状态和引用
const isVisible = ref(false);
const templateRef = ref(null);
let observer = null;

// 处理交叉观察器回调
const handleIntersect = (entries) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      // 使用setTimeout确保DOM更新后再执行
      setTimeout(() => {
        isVisible.value = true;
      }, 50);
      // 一旦可见，可以选择不再观察此元素
      // observer.unobserve(entry.target);
    } else {
      setTimeout(() => {
        isVisible.value = false;
      }, 50);
    }
  });
};

// 生命周期钩子
onMounted(() => {
  // 延迟创建观察器，确保元素已渲染
  setTimeout(() => {
    if (templateRef.value) {
      // 创建交叉观察器，保持持续观察
      observer = new IntersectionObserver(handleIntersect, {
        root: null,
        rootMargin: "0px",
        threshold: 0.1, // 当10%的元素可见时触发
      });

      // 开始观察元素
      observer.observe(templateRef.value);

      // 初始检查：如果元素已经在视窗内，立即触发动画
      const rect = templateRef.value.getBoundingClientRect();
      const isInViewport = rect.top < window.innerHeight && rect.bottom >= 0;
      if (isInViewport) {
        isVisible.value = true;
      }
    }
  }, 100);
});

onUnmounted(() => {
  if (observer && templateRef.value) {
    observer.unobserve(templateRef.value);
    observer.disconnect();
  }
});
</script>

<!-- 添加组件描述注释 -->
<!-- 4号模板组件：产品特性展示页面，左侧文字描述，右侧产品图片 -->

<template>
  <div class="template-4" ref="templateRef" :class="{ 'fade-in': isVisible }">
     <el-icon
        class="order-number"
        color="#222"
        size="20"
        @click="emit('order', $event)"
        v-if="isLoggedIn"
      >
        <DCaret />
      </el-icon>
    <!-- 删除按钮 -->
    <el-icon class="delete-button" @click="handleDelete" v-if="isLoggedIn">
      <Delete />
    </el-icon>

    <!-- 产品特性展示容器 -->
    <div class="feature-container">
      <!-- 左侧文字区域 -->
      <div class="text-section">
        <!-- 标题 -->
        <div>
          <TextCom :contentId="props.templateId + '-text-1'" class="title-en" />
        </div>
        <div>
          <TextCom :contentId="props.templateId + '-text-2'" class="title-zh" />
        </div>
        <!-- 特性列表 -->
        <div class="features-list">
          <div class="feature-item">
            <TextCom
              :contentId="props.templateId + '-text-3'"
              class="feature-value"
            />
            <TextCom
              :contentId="props.templateId + '-text-4'"
              class="feature-desc"
            />
          </div>
          <div class="feng-ge"></div>
          <div class="feature-item">
            <TextCom
              :contentId="props.templateId + '-text-5'"
              class="feature-value"
            />
            <TextCom
              :contentId="props.templateId + '-text-6'"
              class="feature-desc"
            />
          </div>
          <div class="feng-ge"></div>
          <div class="feature-item">
            <TextCom
              :contentId="props.templateId + '-text-7'"
              class="feature-value"
            />
            <TextCom
              :contentId="props.templateId + '-text-8'"
              class="feature-desc"
            />
          </div>
        </div>
      </div>

      <!-- 右侧图片区域 -->
      <div class="image-section">
        <ContainerCom
            :contentId="props.templateId + '-container'"
            :showDelete="true"
            :allowFullScreenPlay="false"
            @delete="handleDelete"

          >
          </ContainerCom>
      </div>
    </div>
  </div>
  <!-- 使用ContainerCom作为主容器 -->
</template>

<style scoped>
.template-4 {
  height: 100vh;
  width: 100%;
  margin: 0 auto;
  opacity: 0;
  transform: translateY(20px);
  transition: opacity 1s ease-out, transform 1s ease-out;
  position: relative;
}

/* 淡入动画类 */
.template-4.fade-in {
  opacity: 1;
  transform: translateY(0);
}

/* 产品特性展示主容器 */
.feature-container {
  display: flex;
  align-items: stretch; /* 修改为stretch，让子元素拉伸到相同高度 */
  justify-content: space-between;
  padding: 2vw 0vw 2vw 13vw;
  height: 100%;
  box-sizing: border-box;
}

/* 左侧文字区域 */
.text-section {
  padding-right: 5%;
  display: flex;
  flex-direction: column;
  justify-content: center; /* 垂直居中内容 */
}
.feng-ge {
  border-top: 1px solid #e5e5e5;
  /* padding-top: 20px; */
}
/* 右侧图片区域 */
.image-section {
  /* flex: 1; */
  display: flex;
  align-items: center; /* 垂直居中图片 */
  justify-content: center; /* 水平居中图片 */
  background: #f5f5f5; /* 添加背景色以便调试 */
  width: 62vw;
  /* min-height: 800px; */
}

/* 英文标题 */
.title-en {
  /* font-size: 1.2rem; */
  /* font-weight: 500; */
  /* margin-bottom: 10px; */
  /* opacity: 0.7; */
  /* letter-spacing: 2px; */
}

/* 中文标题 */
.title-zh {
  font-size: 3rem;
  font-weight: 700;
  margin-bottom: 50px;
  color: #333;
  line-height: 1.2;
}

/* 特性列表 */
.features-list {
  display: flex;
  flex-direction: column;
  gap: 40px;
}

/* 单个特性项 */
.feature-item {
  display: flex;
  align-items: flex-start;
  gap: 20px;
}
/* .feature-item + .feature-item {
  border-top: 1px solid #e5e5e5;
  padding-top: 20px;
} */

/* 特性值 */
.feature-value {
  /* font-size: 2.5rem; */
  font-weight: 700;
  color: #1a73e8;
  min-width: 80px;
}

/* 特性描述 */
.feature-desc {
  font-size: 1rem;
  color: #666;
  line-height: 1.6;
  max-width: 300px;
}

/* 产品图片容器 */
.product-images {
  height: 100%;
  width: 100%;
}

/* 单个产品图片容器 */
.product-image-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 300px;
  width: 200px;
}

/* 产品图片 */
.product-image {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

/* 删除按钮 */
.delete-button {
  position: absolute;
  top: 20px;
  right: 20px;
  background-color: #f56c6c;
  color: #fff;
  border: none;
  padding: 2px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 20px;
  transition: all 0.3s ease;
  z-index: 1000;
}
.delete-button:hover {
  background-color: #f78989;
  color: white;
  transform: scale(1.05);
}
.order-number {
  position: absolute;
  top: 20px;
  right: 40px;
   border: none;
  padding: 2px;
  /* padding: 8px 16px; */
  border-radius: 4px;
  cursor: pointer;
  /* font-size: 14px; */
  transition: all 0.3s ease;
  z-index: 1000;
  margin-right: 8px;
    background-color: #fff;
}
.order-number:hover {
  background-color: #fff;
  transform: scale(1.05);
}

/* 确保容器样式正确 */


/* 响应式设计 */
@media (max-width: 768px) {
  .template-4 {
    height: auto;
  }
  .feature-container {
    flex-direction: column-reverse;
    text-align: center;
    padding: 2rem 2rem;
  }

  .text-section {
    padding-right: 0;
    margin-bottom: 50px;
  }

  .feature-item {
    justify-content: center;
  }

  .title-zh {
    font-size: 2.5rem;
  }
  .image-section {
    height: 50vh;
    width: 100%;
    flex: none;
    display: block;
    /* min-height: 40vh; */
  }
}
</style>
